import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { OktaAuth } from '@okta/okta-auth-js';
import { QualtricsApiService } from 'src/app/shared/services/qualtrics-api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { OktaUser } from 'src/app/shared/models/okta-user';
import { OKTA_AUTH } from '@okta/okta-angular';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  standalone: false
})
export class AuthenticationComponent implements OnInit {
  isAuthenticated!: boolean;
  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth, public qualtricsApiService: QualtricsApiService, 
    private readonly router: Router, private readonly spinner: NgxSpinnerService,
    @Inject(SESSION_STORAGE) private readonly storage: WebStorageService ) { }

  async ngOnInit() {
    if(this.storage.get("contact") !== undefined){
      this.router.navigate([`disclaimer`]);
    }
    else{
      this.spinner.show();
      this.isAuthenticated = await this.oktaAuth.isAuthenticated();
      if(this.isAuthenticated){
        this.oktaAuth.getUser().then(info => {
          // this will need to be changed to the role
          if(info.groups_id === null || info.groups_id === undefined){
            this.router.navigate([`unauthorized`]);
            this.spinner.hide();
          }
          else if (Array.isArray(info.groups_id)){
            if(info.groups_id.indexOf('National Survey Portal-Analyst') !== -1 || info.groups_id.indexOf('National Survey Portal (Non-Prod)-Analyst') !== -1
              ||info.groups_id.indexOf('National Survey Portal-Power Analyst') !== -1 || info.groups_id.indexOf('National Survey Portal (Non-Prod)-Power Analyst') !== -1  ){
                const oktaUser = new OktaUser(info.given_name ?? '', info.family_name ?? '', true, String(info.rssdid) ?? '', info.email ?? '');
                this.storage.set("oktaUser", oktaUser);
                this.storage.set('authenticateUser', 'true');
                this.router.navigate([`disclaimer`]);
                this.spinner.hide();
            }          
            else if(info.groups_id.indexOf('National Survey Portal-Survey Respondent') !== -1 || info.groups_id.indexOf('National Survey Portal (Non-Prod)-Survey Respondent') !== -1){
                const oktaUser = new OktaUser(info.given_name ?? '', info.family_name ?? '', false, String(info.rssdid) ?? '', info.email ?? '');
                this.storage.set("oktaUser", oktaUser);
                this.storage.set('authenticateUser', 'true');
                this.router.navigate([`disclaimer`]);
                this.spinner.hide();
            }
            else {
              this.router.navigate([`unauthorized`]);
              this.spinner.hide();
            }
          }
          else{
            this.router.navigate([`unauthorized`]);
            this.spinner.hide();
          }
        });  
      }
      else{
        this.router.navigate([`unauthorized`]);
        this.spinner.hide();
      }
    }
  }

}
